<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 使用原材料一覧
        v-layout(row wrap).white_container.pa-5.justify-center
          v-container
            v-flex.pb-5(xs12 v-for='(item,index) in items' :key='item.key' :id="item.key")
              h2 {{ item.name }}
              table
                thead
                  tr
                    th(v-for='(item,index) in item.head' :key='item.title') {{ item.title }}
                tbody
                  tr(v-for='(item,index) in item.materials' :key='item.name')
                    td {{ item.name }}
                    td {{ item.country }}
                    td {{ item.allergen }}
    CommonFooter

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
  },
  data () {
    return {
      items: [
        {
          key: 'minimaul_meat',
          name: 'ミニマウルタッシェンミート',
          head: [
            {
              title: '原材料名'
            }, {
              title: '原産国'
            }, {
              title: 'アレルゲン'
            }
          ],
          materials: [
            {
              name: 'セモリナ粉',
              country: 'ドイツ、フランス',
              allergen: '小麦'
            }, {
              name: '豚肉',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: 'パン粉',
              country: 'ドイツ',
              allergen: '小麦'
            }, {
              name: 'ほうれん草',
              country: 'ベルギー',
              allergen: ''
            }, {
              name: '玉ねぎ',
              country: 'ポーランド',
              allergen: ''
            }, {
              name: '卵',
              country: 'ドイツ',
              allergen: '卵'
            }, {
              name: 'ラード',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '食塩',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '澱粉（非組換）',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: 'パセリ',
              country: 'フランス',
              allergen: ''
            }, {
              name: '香辛料',
              country: 'EU、worldwide',
              allergen: ''
            }, {
              name: '砂糖',
              country: '',
              allergen: ''
            }, {
              name: 'pH調整剤',
              country: 'EU、worldwide',
              allergen: ''
            }, {
              name: '香辛料抽出物',
              country: 'EU、worldwide',
              allergen: ''
            }, {
              name: '水',
              country: '',
              allergen: ''
            }
          ]
        }, {
          key: 'minimaul_cheese',
          name: 'ミニマウルタッシェンチーズ',
          head: [
            {
              title: '原材料名'
            }, {
              title: '原産国'
            }, {
              title: 'アレルゲン'
            }
          ],
          materials: [
            {
              name: 'セモリナ粉',
              country: 'ドイツ、フランス',
              allergen: '小麦'
            }, {
              name: '水',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: 'ナチュラルチーズ',
              country: 'ドイツ',
              allergen: '乳'
            }, {
              name: '卵白',
              country: 'ドイツ',
              allergen: '卵'
            }, {
              name: '卵',
              country: 'ドイツ',
              allergen: '卵'
            }, {
              name: '小麦粉',
              country: 'ドイツ、フランス',
              allergen: '小麦'
            }, {
              name: '澱粉（非組換）',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '植物脂肪',
              country: 'アジア、EU',
              allergen: ''
            }, {
              name: '食塩',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '植物油',
              country: 'EU、ウクライナ',
              allergen: ''
            }, {
              name: '香辛料',
              country: 'EU、USA',
              allergen: ''
            }, {
              name: '糖類',
              country: 'フランス',
              allergen: ''
            }, {
              name: '香辛料抽出物',
              country: 'worldwaide',
              allergen: ''
            }
          ]
        }, {
          key: 'schupfnudeln',
          name: 'フィンガーポテト',
          head: [
            {
              title: '原材料名'
            }, {
              title: '原産国'
            }, {
              title: 'アレルゲン'
            }
          ],
          materials: [
            {
              name: 'じゃがいも',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '小麦粉',
              country: 'ドイツ',
              allergen: '小麦'
            }, {
              name: '卵',
              country: 'ドイツ',
              allergen: '卵'
            }, {
              name: '澱粉（非組換）',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '食塩',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '植物油脂',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '香辛料',
              country: 'EU',
              allergen: ''
            }, {
              name: '増粘多糖類',
              country: 'EU',
              allergen: ''
            }, {
              name: '香辛料抽出物',
              country: 'インド',
              allergen: ''
            }
          ]
        }, {
          key: 'spaetzle',
          name: 'シュペッツレ',
          head: [
            {
              title: '原材料名'
            }, {
              title: '原産国'
            }, {
              title: 'アレルゲン'
            }
          ],
          materials: [
            {
              name: '小麦粉',
              country: 'ドイツ、フランス',
              allergen: '小麦'
            }, {
              name: '卵',
              country: 'ドイツ',
              allergen: '卵'
            }, {
              name: 'セモリナ粉',
              country: 'Europe、Canada',
              allergen: '小麦'
            }, {
              name: '食塩',
              country: 'ドイツ',
              allergen: ''
            }, {
              name: '水',
              country: '',
              allergen: ''
            }
          ]
        }
      ]
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc

table
  width 100%
  th,td
    font-size .8rem
    border-bottom 1px solid desaturate($color-secondary, 30%)
    width 30%
    font-family 'Noto Sans JP', sans-serif

</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Ingredients/index.vue